<template>
    <div id="mysidebar" class="w-11/12">
        <div class="flex justify-center card-background">
            <vx-card class="xl:w-full lg:w-8/12 md:w-full shadow-lg custom-height px-4">
                <action-bar class="action-bar">
                    <template v-slot:left>
                        <vx-action-icon
                            :icon="$vs.rtl ? 'ArrowRightIcon' : 'ArrowLeftIcon'"
                            @click="navBack"
                        >
                        </vx-action-icon>
                        <h2 class="ml-5">{{ details.id ? 'Edit Product' : 'Create Product' }}</h2>
                    </template>
                </action-bar>
                <form ref="form" @submit.prevent="validate" class="">
                    <div class="flex justify-evenly mt-5">
                        <div class="w-6/12 px-2">
                            <div class="w-full">
                                <vx-input
                                    label="Product Name"
                                    v-validate="'required'"
                                    name="Product name"
                                    v-model="details.name"
                                    class="w-full mt-2"
                                    placeholder="Enter product name"
                                />
                                <span
                                    class="text-danger text-sm"
                                    v-show="errors.has('Product name')"
                                    >{{ errors.first('Product name') }}</span
                                >

                                <vx-input
                                    label="Product Price"
                                    v-validate="'required'"
                                    name="Product price"
                                    type="number"
                                    min="0"
                                    class="w-full mt-2"
                                    v-model="details.price"
                                    step=".01"
                                />
                                <span
                                    class="text-danger text-sm"
                                    v-show="errors.has('Product price')"
                                    >{{ errors.first('Product price') }}</span
                                >

                                <vx-input
                                    label="Stock keeping unit (SKU)"
                                    v-validate="'required'"
                                    name="sku"
                                    v-model="details.sku"
                                    class="w-full mt-2"
                                    placeholder="Enter stock keeping unit (SKU)"
                                />
                                <span class="text-danger text-sm" v-show="errors.has('sku')">{{
                                    errors.first('sku')
                                }}</span>

                                <vx-input
                                    label="Keywords"
                                    v-validate="'required'"
                                    name="Keywords"
                                    v-model="details.keywords"
                                    class="w-full mt-2"
                                    placeholder="Enter product keywords"
                                />
                                <span class="text-danger text-sm" v-show="errors.has('Keywords')">{{
                                    errors.first('Keywords')
                                }}</span>

                                <vx-input
                                    label="Stripe price ID"
                                    v-validate="'required'"
                                    name="stripe price ID"
                                    v-model="details.stripePriceID"
                                    class="w-full mt-2"
                                    placeholder="Enter stripe price ID"
                                />
                                <span
                                    class="text-danger text-sm"
                                    v-show="errors.has('stripe price ID')"
                                    >{{ errors.first('stripe price ID') }}</span
                                >
                            </div>
                        </div>
                        <div class="w-6/12 px-2">
                            <div class="w-full">
                                <vx-textarea
                                    label="Product short description"
                                    v-model="details.shortDescription"
                                    rows="3"
                                    class="w-full mt-3"
                                    placeholder="Enter product short description"
                                ></vx-textarea>

                                <vx-textarea
                                    label="Product long description"
                                    v-model="details.longDescription"
                                    rows="3"
                                    class="w-full -mt-1"
                                    placeholder="Enter product long description"
                                ></vx-textarea>
                            </div>
                        </div>
                    </div>

                    <div class="flex justify-center mt-10 relative">
                        <button type="submit" class="create w-1/6 h-12 z-50">
                            {{ productID ? 'Save' : 'Create' }}
                        </button>
                    </div>
                </form>
            </vx-card>
        </div>
    </div>
</template>

<script>
import ActionBar from '@/components/custom/ActionBar'
import { mapParams } from '@/plugins/mappers'

export default {
    name: 'create-product',
    components: {
        ActionBar
    },
    computed: {
        ...mapParams({
            url_id: 'product_id'
        }),
        productID() {
            return this.url_id
        }
    },
    props: {},
    data() {
        return {
            loading: false,
            details: {
                productName: null,
                sku: null,
                productShortDescription: '',
                productLongDescription: '',
                price: 0,
                keywords: null,
                stripePriceID: null
            }
        }
    },
    methods: {
        validate() {
            this.loading = true
            this.$validator.validateAll().then(async (result) => {
                if (result) {
                    try {
                        var response
                        if (this.details.id) {
                            //todo:update
                            response = await this.$api.product.updateProduct(this.details)
                            this.notifySuccess(
                                'Updated successfully',
                                'Product Updated successfully.',
                                5000
                            )
                        } else {
                            //create
                            response = await this.$api.product.createProduct(this.details)
                            this.notifySuccess(
                                'Created successfully',
                                'Product created successfully.',
                                5000
                            )
                            this.$router.replace(`/products/${response.id}`)
                        }
                    } catch (err) {
                        console.error(err)

                        this.notifyError('Error', `Error message: ${err}`, 5000)
                    } finally {
                        this.loading = false
                    }
                }
            })
            this.loading = false
        },
        navBack() {
            this.$router.go(-1)
        },
        async getDetails() {
            if (this.productID) {
                this.loading = true
                try {
                    this.details = await this.$api.product.fetchProduct(this.productID)
                } catch (err) {
                    console.error(err)
                    this.notifyError(
                        'Communication Error',
                        'Could not retrieve product details from server, please check your connection and try again.',
                        2000
                    )
                } finally {
                    this.loading = false
                }
            }
        }
    },
    watch: {
        productID: {
            handler: async function (product_id) {
                if (product_id) {
                    await this.getDetails()
                }
            },
            immediate: true
        }
    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Barlow:wght@300;400;500;600;700;800&family=Playfair+Display:wght@400;500;600;700;800&display=swap');
.croc {
    position: absolute;
    left: 10px;
    bottom: -40px;
}
.card-background {
    background: transparent;
    height: 100%;
}
.custom-height {
    min-height: 540px;
}
.create {
    border: none;
    border-radius: 50px;
    background-color: #9dd6cd;
    color: #fff;
    font-size: 1.5rem;
    box-shadow: 0px 2px 6px 0.5px #bebebe;
    cursor: pointer;
    font-family: 'Playfair Display', serif;
    letter-spacing: 2px;
}
a {
    font-size: 1rem;
}
p {
    color: #949c9c;
}
li {
    color: #949c9c;
    font-size: 1.1rem;
}
</style>
